











import pusher from '@/lib/pusher';
import { Component, Vue } from 'vue-property-decorator';
import api_client from '@/lib/api_client';

@Component
export default class Dashboard extends Vue {
  public games = [];
  public async mounted() {
    await this.loadGames();
    this.setupWebsocket();
  }

  public get envName() {
    return process.env.VUE_APP_ENV !== undefined
      ? process.env.VUE_APP_ENV
      : 'development';
  }

  public get channelName() {
    return `${this.envName}-games`;
  }

  public won(game, teamId) {
    if (!game.winning_team) {
      return false;
    }
    return teamId === game.winning_team.winning_team_id;
  }

  public async loadGames() {
    this.games = (await api_client.get('/games')).data;
  }

  public setupWebsocket() {
    const channel = pusher.subscribe(this.channelName);
    channel.bind('update', (data) => {
      this.loadGames();
    });
  }
}
